module.exports = "https://www.gc-qa.gnp.com.mx/4267fa229292bb5564997257e5248c75.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/reembolso-gmm/03.png
// module id = 1049
// module chunks = 0 1